import type { ReactNode } from "react";

export function Card({
  children,
  style,
  padding = 20,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
  padding?: number;
}) {
  return (
    <div
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-md)",
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function CardTitle({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <h2
      style={{
        margin: 0,
        marginBottom: 8,
        fontSize: 16,
        fontWeight: 700,
        color: "var(--text-primary)",
        ...style,
      }}
    >
      {children}
    </h2>
  );
}

export function CardSubtle({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div
      style={{
        fontSize: 13,
        color: "var(--text-muted)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
